import { render, staticRenderFns } from "./form-row.vue?vue&type=template&id=40157f66&scoped=true"
import script from "./form-row.vue?vue&type=script&lang=ts"
export * from "./form-row.vue?vue&type=script&lang=ts"
import style0 from "./form-row.vue?vue&type=style&index=0&id=40157f66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40157f66",
  null
  
)

export default component.exports